import React, { useState, useEffect } from 'react';
import { postCategoryServices } from 'api/services';
import {
  Grid,
  MenuItem,
  Paper,
  Select,
  FormControl,
  InputLabel,
  TextField,
  Typography,
} from '@material-ui/core';
import { Button } from '@material-ui/core';
import Loader from 'react-loader-spinner';
import handleNotification from 'helpers/handleNotification';
import { FileUploader } from 'shared/FileUploader/FileUploader';
import { MainTemplate } from 'shared/MainTemplate/MainTemplate';
import { IPostCategory } from 'api/services/postCategories/types';
import { useHistory, useParams } from 'react-router-dom';
import { templateServices } from 'api/services';
import { IResTemplate } from 'api/services/templates/types';
import getImageByImageSize from 'helpers/getImageByImageSize';
import { IFile } from 'api/services/file/types';
import { transliterate } from 'helpers/transliterate';
import { AppState } from 'store/store';
import { useSelector } from 'react-redux';
import './CreatePostCategoryPage.sass';

export const CreatePostCategoryPage: React.FC = () => {
  const [name, setName] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [file, setFile] = useState<IFile>();
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [templateId, setTemplateId] = useState<number>();
  const [templates, setTemplates] = useState<IResTemplate[]>([]);
  const { taxonomyId } = useParams<{ taxonomyId: string }>();
  const { currentLang } = useSelector((state: AppState) => state.langReducer);
  const history = useHistory();

  useEffect(() => {
    if (currentLang?.code) getTemplates();
  }, [currentLang?.code]);

  const getTemplates = async () => {
    const res = await templateServices
      .getTemplates({ taxonomyId })
      .then((res) => res.data);
    setTemplates(res);
  };

  const createPost = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!name.trim() || !title.trim() || !templateId) {
      handleNotification('Заполните поля');
      setHasError(true);
      return;
    }
    setLoading(true);

    const requestData: IPostCategory = {
      name,
      description,
      title,
      fileId: file?.id || undefined,
      taxonomyId: Number(taxonomyId),
      templateId,
    };

    try {
      await postCategoryServices.createPostCategory(requestData);
      history.push(`/taxonomies/${taxonomyId}/categories`);
      handleNotification('Категория сохранена', 'success');
    } catch {
      setLoading(false);
      handleNotification('Ошибка попробуйте позже');
    }
  };

  const generationName = (value: string) => {
    setTitle(value);
    setName(transliterate(value));
  };

  return (
    <MainTemplate title="Создание категории" hideBtn>
      <Grid container alignItems="flex-start">
        <Grid item md={8} className="create-post-category-page__main">
          <TextField
            autoFocus
            variant="outlined"
            label="Заголовок"
            className="form-field"
            value={title}
            onChange={(e) => generationName(e.target.value as string)}
            error={hasError && !title.trim()}
          />
          <TextField
            variant="outlined"
            label="Описание"
            className="form-field"
            value={description}
            multiline
            minRows={3}
            onChange={(e) => setDescription(e.target.value as string)}
          />
          <FormControl
            variant="outlined"
            error={!templateId && hasError}
            className="form-field"
          >
            <InputLabel id="categories">Шаблон по умолчанию</InputLabel>
            <Select
              label="Шаблон по умолчанию"
              value={templateId}
              onChange={(e) => setTemplateId(Number(e.target.value as string))}
            >
              {templates?.map((i) => {
                return (
                  <MenuItem key={i.id} value={i.id}>
                    {i.title}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          {/* <FormControl
            variant="outlined"
            className="form-field"
            error={!templateId && hasError}
          >
            <InputLabel id="categories">Шаблоны</InputLabel>
            <Select
              label="Шаблон"
              value={templateId}
              onChange={(e) => setTemplateId(e.target.value as number)}
            >
              {templates?.map((i) => (
                <MenuItem key={i.id} value={i.id}>
                  {i.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}

          {/* <div className="form-field">
            <Form ref={formRef} view={componentView} fields={properties} />
          </div> */}
        </Grid>
        <Grid
          md={4}
          container
          className="create-post-category-page__aside"
          spacing={2}
        >
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              label="Название"
              className="form-field"
              value={name}
              onChange={(e) => setName(transliterate(e.target.value as string))}
              error={hasError && !name.trim()}
            />
          </Grid>
          <Grid item xs={12}>
            <Paper variant="outlined">
              <Grid container spacing={3} alignItems="stretch">
                <Grid item xs={7} className="post-page__block">
                  <Typography
                    variant="h4"
                    style={{ marginBottom: '20px' }}
                    className="post-page__block-title"
                  >
                    Медиа
                  </Typography>
                  <FileUploader text="Выбрать файл" selectFile={setFile} />
                </Grid>
                <Grid
                  className="post-page__media"
                  container
                  item
                  alignItems="center"
                  xs={5}
                >
                  {file ? (
                    <img
                      className="post-page__media-item"
                      src={getImageByImageSize({
                        file,
                        imageSize: '200x200',
                      })}
                      alt=""
                    />
                  ) : (
                    <Typography className="media-item-title" variant="h6">
                      Изображение не выбрано
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} justifyContent="flex-end" container>
            <Button
              className="action-button"
              size="large"
              color="primary"
              variant="contained"
              onClick={createPost}
              disabled={loading}
            >
              {loading ? (
                <Loader height={10} type="ThreeDots" color="#fff" />
              ) : (
                'Создать категорию'
              )}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </MainTemplate>
  );
};
